import {createSelector} from 'reselect';
import {AppState} from '../../index';

export const notificationsSelector = () =>
  createSelector(
    (state: AppState) => state.snackbar.notifications,
    (item) => item,
  );
